import { render, staticRenderFns } from "./posterCard.vue?vue&type=template&id=a08b0978&scoped=true&"
import script from "./posterCard.vue?vue&type=script&lang=js&"
export * from "./posterCard.vue?vue&type=script&lang=js&"
import style0 from "./posterCard.vue?vue&type=style&index=0&id=a08b0978&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08b0978",
  null
  
)

export default component.exports